export default __webpack_public_path__ + "static/media/049-umbrella.13c8a81f.svg";